var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 66,
    viewBox: "0 0 104 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 41.4C15.1716 41.4 14.5 42.0716 14.5 42.9C14.5 43.7284 15.1716 44.4 16 44.4H48C48.8284 44.4 49.5 43.7284 49.5 42.9C49.5 42.0716 48.8284 41.4 48 41.4H16ZM16 51.3C15.1716 51.3 14.5 51.9716 14.5 52.8C14.5 53.6284 15.1716 54.3 16 54.3H32C32.8284 54.3 33.5 53.6284 33.5 52.8C33.5 51.9716 32.8284 51.3 32 51.3H16ZM102.5 15H1.5V9.9C1.5 7.77553 2.52082 5.66419 4.46929 4.0567C6.42597 2.44244 9.13186 1.5 12 1.5H92C94.8681 1.5 97.574 2.44244 99.5307 4.0567C101.479 5.66419 102.5 7.77553 102.5 9.9V15ZM1.5 18H102.5V18.3H1.5V18ZM102.5 21.3V56.1C102.5 58.2245 101.479 60.3358 99.5307 61.9433C97.574 63.5576 94.8681 64.5 92 64.5H12C9.13186 64.5 6.42597 63.5576 4.46929 61.9433C2.52082 60.3358 1.5 58.2245 1.5 56.1V21.3H102.5Z",
    stroke: "#013847",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/PaymentIcon.42f4def468367574eb4331ba66a0c154.svg";
export { ForwardRef as ReactComponent };